/**
 * Office.js initialization helper.
 *
 * Wraps Office.onReady() in a typed promise and validates that
 * the add-in is running inside Microsoft Word.
 */

/** Result returned after Office.js initialises successfully. */
export interface OfficeInitResult {
  /** The Office host application (should be Word). */
  host: Office.HostType;
  /** The Office platform (Win32, Mac, Web, iOS, Android). */
  platform: Office.PlatformType;
}

/**
 * Initialise Office.js and verify we are running in Word.
 *
 * @returns Resolved OfficeInitResult when Office is ready.
 * @throws If the host is not Microsoft Word.
 */
export async function initializeOffice(): Promise<OfficeInitResult> {
  if (new URLSearchParams(window.location.search).get('mockOffice') === '1') {
    return {
      host: typeof Office !== 'undefined' ? Office.HostType.Word : ('Word' as unknown as Office.HostType),
      platform: typeof Office !== 'undefined' ? Office.PlatformType.PC : ('PC' as unknown as Office.PlatformType),
    };
  }

  const info = await Office.onReady();

  if (info.host !== Office.HostType.Word) {
    throw new Error(
      `Alterspective Advice requires Microsoft Word. Detected host: ${info.host ?? 'unknown'}`
    );
  }

  return {
    host: info.host,
    platform: info.platform,
  };
}
